<template>
  <ModalC v-show="showModalObj.status" :widthContainer="'60%'">
    <template v-slot:header>
      <div class="w-full flex justify-between">
        <h3 style="font-weight: 700; font-family: Lato; color: #810042">
          Observación
        </h3>
      </div>
    </template>
    <template v-slot:body>
      <textarea
        v-if="showModalObj.type == 'add_comment'"
        name="textarea"
        rows="5"
        cols="87"
        id="commentDocuments"
        v-model="comment"
        style="padding: 10px; border: 1px solid #ffc300;border-radius: 5px;
          font-family: Arial, Helvetica, sans-serif;
          color: grey;
          width: 100%;
          height: 150px;
        "
      ></textarea>
      <div
        v-if="showModalObj.type == 'view_comments'"
        class="h-44 overflow-scroll mb-5"
      >
         <div v-if="Object.keys(documents[document_type].comments).length == 0">
          No hay comentarios
        </div>
        <p class="flex break-words break-all mb-2" v-for="(comment, key) in documents[document_type].comments" :key="comment.comment">
          {{key}}.- {{ comment.comment }}
        </p>
        
      </div>
      <button
      v-if="showModalObj.type == 'view_comments'"
       class=" block mx-auto px-2 border border-green-500 rounded text-green-500" @click="closeModalComments()">Cerrar</button>


    </template>
    <template v-slot:footer v-if="showModalObj.type == 'add_comment'">
      <input
        class="text-gray-400 cursor-pointer"
        type="button"
        value="Cancelar"
        @click="closeModalComments()"
      />
      <input
        class="px-2 text-green-500 border-green-500 border rounded hover:bg-green-500 hover:text-white cursor-pointer"
        type="button"
        value="Añadir"
        @click="saveComment()"
        style="margin-left: 10px"
      />
    </template>
  </ModalC>
  <div
    class="md:col-span-1 col-span-2 mb-2"
    style="
      font-family: Roboto;
      padding: 10px;
      background: #fff;
      border-width: 2px;
      border-style: solid;
      border-radius: 7px;
    "
    :class="classList.container"
  >
    <p
      class="ml-3"
      style="
        font-size: 16px;
        font-family: lato;
        font-weight: 700;
      "
      :class="classList.title"
    >
      Control de Documentos Inscripción del Socio
    </p>
    <div
      v-for="(doc, key) of documents" :key="key"
    >
    <div 
      v-if="doc.max_documents_required > 0 || doc.max_documents_required == null"
      class="md:grid md:grid-cols-12 grid grid-cols-12 mb-2">
      <div 
        class="col-span-5 ml-3"
        :class="classList.items_files">
        <p
          style="
            font-size: 12px;
            color: grey;
            font-family: lato;
            font-weight: 400;
          "
        >
          {{ formatDocumentName(getParamTranslated(key)) }} <span v-if="!doc.optional" class="text-red-500">*</span>
        </p>
      </div>
      <div class="col-span-3">
        <CheckBox
          :idCheckBox="key"
          v-on:change-date-value="validateDocument($event, key)"
          :key="key"
          :cheked="doc.validated"
        />
      </div>
      <div class="col-span-3">
        <div class="flex comment md:float-right mt-2">
          <button
            class="border-2 rounded"
            style="padding: 5px; outline: none"
            @click="openModalComments(key, 'add_comment', index)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13.142"
              height="13.142"
              viewBox="0 0 13.142 13.142"
            >
              <path
                id="svgImgAutorizacionDescuentoNomina"
                d="M13.828,2H3.314A1.318,1.318,0,0,0,2,3.314V11.2a1.318,1.318,0,0,0,1.314,1.314h9.2l2.628,2.628V3.314A1.318,1.318,0,0,0,13.828,2ZM12.514,9.885H4.628V8.571h7.885Zm0-1.971H4.628V6.6h7.885Zm0-1.971H4.628V4.628h7.885Z"
                transform="translate(-2 -2)"
                fill="#35ba91"
              />
            </svg>
          </button>

          <button
            class="border-2 rounded relative"
            style="padding: 5px; outline: none"
            @click="
              openModalComments(key, 'view_comments', index)
            "
          >
          <span
          style="font-family: Arial, Helvetica, sans-serif;"
           class="py-1 px-2 absolute -top-4 -right-3 text-xs text-white rounded-full bg-green-500 " v-if="Object.keys(doc.comments).length >= 1">
               {{ Object.keys(doc.comments).length }}
          </span>
         
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                style="color: rgb(53, 186, 145)"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
              <path
                style="color: rgb(53, 186, 145)"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
    </div>
    <hr />
    <div class="grid grid-cols-1 mt-10">
      <p
        data-v-6b0797aa=""
        style="font-size: 16px;font-family: lato; font-weight: 700;
        "
        :class="classList.text_footer"
      >
        Enviar notificación de documentos faltantes
      </p>

        <button 
          :disabled="missingDocuments().length <= 0"
          :class="[missingDocuments().length <= 0 && 'opacity-50 cursor-not-allowed']"
          @click="sendMissingDocuments()"
          class="w-full py-2 bg-green-500 cursor-pointer  buttonSave text-white shadow-md"
          name="btn_send_message_documents"
          id="btn_send_message_documents"
        >
        Enviar correo
        </button>
    </div>
  </div>
 
</template>

<script>
import { ref } from "vue";
import CheckBox from "./components/CheckBox.vue";
import ModalC from "./components/ModalC.vue";
import Swal from "sweetalert2";
export default {
  name: "DocumentControlList",
  components: {
    CheckBox,
    ModalC,
  },
  emits: ["sendMissingDocuments", "validateCheckboxList"],
  props:{
    documentsList: {
      type: Object
    },
    classList: {
      type: Object,
      default(){
        return {
          container: "",
          title: "text-orange-500",
          items_files: "",
          text_footer: "text-orange-500",
        }
      }
    }

  },
  setup(props,_ctx) {
    //falta que desde el back venga nodo para validar si se muestra archivo
    //const documents = ref(document_list.response.documents);
    const documents = ref(props.documentsList);
    const documentsFilted = ref({})
    //documents.value = documents.value.filter(obj => obj.max_documents_required >0 && obj.max_documents_required == null);
    for(let doc in documents.value){
      if(documents.value[doc].max_documents_required > 0 || documents.value[doc].max_documents_required == null){
        documentsFilted.value[doc] = documents.value[doc];
      }
    }
    //console.log("documentsFilted: ", documentsFilted.value);
    const comment = ref("");
    const indexComments = ref(0);
    const document_type = ref("");
    const showModalObj = ref({
      status: false,
      type: "",
    });
     const paramsToTranslate = {
      identificación_oficial: "identification",
      curp: "curp",
      comprobante_de_domicilio: "proof_of_residency",
      comprobantes_de_ingresos: "proof_of_income",
      comprobante_de_ingresos: "proof_of_income",
      estado_de_cuenta: "bank_statement",
      último_estado_de_cuenta_bancario: "bank_statement",
      autorizo_descuento_ahorro: "discount_authorization",
      autorizo_de_descuento: "discount_authorization",
      rfc_o_firma_electrónica_avanzada: "rfc",
      recibo_pago_parte_social: "enroll_payment_fee",
      constancia_de_situación_fiscal: "proof_of_tax_situation",
      solicitud_de_ingreso: "application_for_admission",
      certificado_aportacion_social: "social_contribution_certificate",
      contrato_de_ahorro: "savings_contract",
      acta_de_nacimiento: "birth_certificate",
      selfie_con_ine: "selfie_with_identification",
      alta_ahorro: "register_savings",
      alta_ahorro_simple: "register_savings_simple",
      alta_ahorro_cabsa: "register_savings_cabsa",
      alta_ahorro_simple_2: "register_savings_simple_2",
      verificación_de_vídeo: "video_verification",
}

    const missingRequiredDocuments = () => {
      const listDocumentsMissingRequired = [];
      for(let doc in documentsFilted.value){
        if(!documentsFilted.value[doc].validated && !documentsFilted.value[doc].optional){
          listDocumentsMissingRequired.push(formatDocumentName(getParamTranslated(doc)))
        }
      }
      return listDocumentsMissingRequired
    }
    const missingDocuments = () => {
      const listDocumentsMissing = [];
      for(let doc in documentsFilted.value ){
        if(!documentsFilted.value[doc].validated){
          listDocumentsMissing.push(formatDocumentName(getParamTranslated(doc)))
        }
      }
      return listDocumentsMissing
    }

   
    const validateCheckboxList = () => {
      _ctx.emit('validateCheckboxList', missingRequiredDocuments())

    };
    const validateDocument = (evet, doc) => {
      console.log("doc", doc);
      documents.value[doc].validated = evet
    };
    const openModalComments = (document, typeModal, index) => {
      document_type.value = document;
      showModalObj.value.status = true;
      showModalObj.value.type = typeModal;
      indexComments.value = index;
    };
    const closeModalComments = () => {
      showModalObj.value.status = false;
      comment.value = "";
    };
    const saveComment = () => {
      comment.value = comment.value.trim();
      if (comment.value.length < 20) {
        Swal.fire({
          title: "Error!",
          text: "El comentario no puede ser menor a 19 caracteres",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
        return;
      }
      
      for(let key in documents.value){
        var size = Object.keys(documents.value[key].comments).length;
        if (key === document_type.value) {
          documents.value[key].comments[size + 1] = {id: "", comment: comment.value}
        }
      }
      closeModalComments();
    };

    const sendMissingDocuments = () => {
      _ctx.emit('sendMissingDocuments', missingDocuments())
    }
    const formatDocumentName = (documentName) =>{
      const docFormated = documentName.replaceAll("_", " ")
      let capitalizedStr = docFormated.charAt(0).toUpperCase() + docFormated.slice(1);
      return capitalizedStr
    }
    const getParamTranslated = (prop) => {
      for(let key in paramsToTranslate){
        if(paramsToTranslate[key] === prop){
          return key
        }
      }
      return prop
    }

    return {
      documents,
      comment,
      showModalObj,
      document_type,
      indexComments,
      saveComment,
      validateDocument,
      openModalComments,
      formatDocumentName,
      getParamTranslated,
      closeModalComments,
      validateCheckboxList,
      missingDocuments,
      sendMissingDocuments,
      missingRequiredDocuments
    };
  },
};
</script>
<style>
#btn_send_message_documents{
    border: none;
    border-radius: 5px;
    text-align: center;
    font-size: 12px;
}
</style>



